import { EVENT_TYPES } from "@/lib/events";

export default function Filters({ filters, setFilters, departments }) {
  const toggleType = (t) => setFilters((f) => ({ ...f, type: f.type === t ? "" : t }));

  return (
    <div data-testid="filter-bar" className="flex flex-wrap items-center gap-2">
      {Object.entries(EVENT_TYPES).map(([key, t]) => (
        <button key={key} data-testid={`filter-type-${key}`} onClick={() => toggleType(key)}
          className={`text-xs font-bold px-3 py-2 rounded-full border transition ${filters.type === key ? `${t.bg} text-white ${t.border}` : "bg-slate-900/60 text-slate-300 border-slate-700 hover:border-slate-500"}`}>
          {t.label}
        </button>
      ))}
      <select data-testid="filter-status" value={filters.status} onChange={(e) => setFilters((f) => ({ ...f, status: e.target.value }))}
        className="text-xs h-9 px-2 rounded-lg bg-[#0B0F17] border border-slate-700 text-slate-200">
        <option value="">Tout statut</option>
        <option value="prevu">Prévu</option>
        <option value="en_cours">En cours</option>
        <option value="termine">Terminé</option>
      </select>
      <select data-testid="filter-reliability" value={filters.reliability} onChange={(e) => setFilters((f) => ({ ...f, reliability: e.target.value }))}
        className="text-xs h-9 px-2 rounded-lg bg-[#0B0F17] border border-slate-700 text-slate-200">
        <option value="">Toute fiabilité</option>
        <option value="confirme">Confirmé</option>
        <option value="annonce">Annonce</option>
        <option value="reseaux_sociaux">Réseaux sociaux</option>
      </select>
      <select data-testid="filter-department" value={filters.department} onChange={(e) => setFilters((f) => ({ ...f, department: e.target.value }))}
        className="text-xs h-9 px-2 rounded-lg bg-[#0B0F17] border border-slate-700 text-slate-200">
        <option value="">Tout département</option>
        {departments.map((d) => <option key={d} value={d}>{d}</option>)}
      </select>
    </div>
  );
}
